import { message } from 'antd';
import LoginLayout from './login';
import MainLayout from '@/layouts/Main/mainLayout';
import ContainerLayout from './container/index';
import WebMainLayout from '@/layouts/Main/webMainLayout';
message.config({
    duration: 1.5,
    maxCount: 3,
    rtl: false,
});
const SiriusLayout = {
    LoginLayout,
    MainLayout,
    WebMainLayout,
    ContainerLayout,
};
export default SiriusLayout;
